module.exports = __webpack_public_path__ + "static/media/long-arrow-right.6a41e970.svg";